<div class="generic-filter-toolbar flex items-center gap-2">
    <!-- Global Fields -->
    <ng-container *ngFor="let field of globalFields">
        <!-- Global Text Field -->
        <div *ngIf="field.type === 'text'" class="flex-1">
            <p-iconfield>
                <p-inputicon class="pi pi-search" />
                <input pInputText
                       type="text"
                       [class]="field.width || 'w-96'"
                       [placeholder]="field.placeholder || 'Tìm kiếm...'"
                       [(ngModel)]="filterValues[field.key]"
                       (ngModelChange)="onTextChange(field.key, $event)" />
                <p-inputicon *ngIf="filterValues[field.key]"
                             class="pi pi-times cursor-pointer"
                             (click)="filterValues[field.key] = ''; onTextChange(field.key, '')" />
            </p-iconfield>
        </div>

        <!-- Global Date Range Field -->
        <div *ngIf="field.type === 'dateRange'" class="flex items-center gap-2">
            <p-datepicker
                          class="flex-1"
                          showIcon
                          [iconDisplay]="'input'"
                          [placeholder]="'Từ ngày'"
                          dateFormat="dd/mm/yy"
                          [(ngModel)]="filterValues[field.key].from"
                          (ngModelChange)="onDateRangeChange(field, 'from', $event)"
                          [showClear]="true"
                          stopOnDateSelectPropagation
                          appendTo="body" />
            <span class="text-slate-400">-</span>
            <p-datepicker
                          class="flex-1"
                          showIcon
                          [iconDisplay]="'input'"
                          [placeholder]="'Đến ngày'"
                          dateFormat="dd/mm/yy"
                          [(ngModel)]="filterValues[field.key].to"
                          (ngModelChange)="onDateRangeChange(field, 'to', $event)"
                          [showClear]="true"
                          stopOnDateSelectPropagation
                          appendTo="body" />
        </div>

        <!-- Global Multi-Select Field -->
        <div *ngIf="field.type === 'multiSelect' && field.selectConfig">
            <p-multiselect [options]="selectOptions.get(field.key) || []"
                           [(ngModel)]="filterValues[field.key].values"
                           (ngModelChange)="onMultiSelectChange(field)"
                           [placeholder]="field.selectConfig.placeholder || 'Chọn...'"
                           [filter]="true"
                           (onFilter)="onSelectFilter(field, $event)"
                           [loading]="selectLoading.get(field.key) || false"
                           [showClear]="true"
                           display="chip"
                           [styleClass]="field.width || 'w-full'"
                           optionLabel="label"
                           optionValue="value"
                           appendTo="body">
                <ng-template pTemplate="footer">
                    <div class="px-3 py-2 border-t border-slate-200">
                        <div class="flex items-center gap-2">
                            <span class="text-xs font-medium text-slate-600">Chế độ:</span>
                            <p-selectbutton [options]="matchModeOptions"
                                            [(ngModel)]="filterValues[field.key].mode"
                                            (ngModelChange)="onMatchModeChange(field)"
                                            [disabled]="!field.isArrayField"
                                            [pTooltip]="!field.isArrayField ? 'Trường đơn giá trị, chỉ hỗ trợ chế độ Any' : ''"
                                            optionLabel="label"
                                            optionValue="value"
                                            size="small"
                                            styleClass="text-xs" />
                        </div>
                    </div>
                </ng-template>
            </p-multiselect>
        </div>

        <!-- Global Multi-Select with Priority Field -->
        <div *ngIf="field.type === 'multiSelectPriority' && field.selectConfig">
            <p-multiselect [options]="selectOptions.get(field.key) || []"
                           [(ngModel)]="filterValues[field.key].values"
                           (ngModelChange)="onMultiSelectChange(field)"
                           [placeholder]="field.selectConfig.placeholder || 'Chọn...'"
                           [filter]="true"
                           (onFilter)="onSelectFilter(field, $event)"
                           [loading]="selectLoading.get(field.key) || false"
                           [showClear]="true"
                           display="chip"
                           [styleClass]="field.width || 'w-full'"
                           optionLabel="label"
                           optionValue="value"
                           appendTo="body">
                <ng-template pTemplate="footer">
                    <div class="flex flex-col gap-2 px-3 py-2 border-t border-slate-200">
                        <!-- Match mode toggle -->
                        <div class="flex items-center gap-2">
                            <span class="text-xs font-medium text-slate-600">Chế độ:</span>
                            <p-selectbutton [options]="matchModeOptions"
                                            [(ngModel)]="filterValues[field.key].mode"
                                            (ngModelChange)="onMatchModeChange(field)"
                                            optionLabel="label"
                                            optionValue="value"
                                            size="small"
                                            styleClass="text-xs" />
                        </div>

                        <!-- Priority mode dropdown -->
                        <div *ngIf="field.priorityModeOptions"
                             class="flex items-center gap-2">
                            <span class="text-xs font-medium text-slate-600">Ưu tiên:</span>
                            <p-select [options]="getPriorityModeOptionsWithNumericValues(field.priorityModeOptions)"
                                      [(ngModel)]="filterValues[field.key].priority"
                                      (ngModelChange)="onPriorityModeChange(field)"
                                      optionLabel="label"
                                      optionValue="value"
                                      size="small"
                                      styleClass="flex-1"
                                      appendTo="body"
                                      stopOnOptionSelectPropagation />
                        </div>
                    </div>
                </ng-template>
            </p-multiselect>
        </div>
    </ng-container>

    <!-- Filter Button with Badge -->
    <div *ngIf="hasPopoverFields">
        <!-- Filter Button -->
        <p-button
                  #filterButton
                  icon="pi pi-filter"
                  severity="secondary"
                  [outlined]="true"
                  [badge]="activePopoverFilterCount > 0 ? activePopoverFilterCount.toString() : ''"
                  badgeSeverity="info"
                  pTooltip="Bộ lọc nâng cao"
                  (onClick)="filterPopover.toggle($event)">
        </p-button>

        <!-- Filter View Edit/Create Popover -->
        <generic-popover #filterViewPopover
                         *ngIf="config.showFilterViewPanel && config.entityType"
                         [popoverConfig]="filterViewPopoverConfig"
                         [selectedData]="selectedFilterViewForEdit"
                         [editMode]="filterViewEditMode">
        </generic-popover>
    </div>

    <!-- Filter Popup -->
    <p-popover #filterPopover overlayGuards
               [dismissable]="true"
               [style]="{width: config.showFilterViewPanel ? '650px' : '400px', maxHeight: '500px'}"
               styleClass="filter-toolbar-popover flex"
               appendTo="body">
        <ng-template pTemplate="content">
            <div class="flex flex-1 gap-3 overflow-hidden">
                <!-- Filter View Panel (Left Side) -->
                <div *ngIf="config.showFilterViewPanel && config.entityType"
                     class="filter-view-panel flex-none w-72 border-r border-surface pr-3 flex flex-col overflow-hidden">
                    <!-- Panel Header -->
                    <div class="flex items-center justify-between p-2 mb-2 flex-none gap-2 border-b border-surface">
                        <span class="text-sm font-semibold">Bộ lọc đã lưu</span>
                        <div class="flex gap-1">
                            <p-button icon="pi pi-refresh"
                                      [text]="true"
                                      size="small"
                                      [loading]="isLoadingViews"
                                      (onClick)="loadFilterViews()"
                                      pTooltip="Tải lại" />
                        </div>
                    </div>

                    <!-- Loading State -->
                    <div *ngIf="isLoadingViews" class="text-center py-4 flex-1">
                        <i class="pi pi-spin pi-spinner text-2xl text-slate-400"></i>
                    </div>

                    <!-- Filter Views List -->
                    <div *ngIf="!isLoadingViews" class="flex flex-col gap-4 flex-1 overflow-y-auto pr-1">
                        <!-- Pinned Views -->
                        <div *ngIf="pinnedViews.length > 0" class="filter-view-section">
                            <div class="filter-view-subheader">
                                <i class="pi pi-thumbtack text-xs"></i>
                                <span class="text-xs font-semibold uppercase tracking-wide">Đã ghim</span>
                            </div>
                            <div class="flex flex-col ml-2 border-l border-surface">
                                <div *ngFor="let view of pinnedViews"
                                     class="filter-view-item"
                                     [class.selected]="selectedViewId === view.id"
                                     (click)="selectFilterView(view)">
                                    <div class="flex items-center justify-between gap-1 h-8 relative">
                                        <div class="flex items-center gap-2 flex-1 min-w-0">
                                            <span class="text-sm truncate">{{ view.name }}</span>
                                            <span *ngIf="view.isShared"
                                                  class="text-xs px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded flex-none">
                                                Shared
                                            </span>
                                        </div>
                                        <div class="filter-view-actions flex gap-1 flex-none absolute right-0">
                                            <p-button icon="pi pi-pencil"
                                                      [text]="true"
                                                      size="small"
                                                      severity="secondary"
                                                      *ngIf="!view.isShared || hasSharedManagePermission"
                                                      (onClick)="openEditFilterViewPopover(view, $event); $event.stopPropagation()"
                                                      pTooltip="Chỉnh sửa" />
                                            <p-button icon="pi pi-thumbtack"
                                                      [text]="true"
                                                      size="small"
                                                      severity="secondary"
                                                      *ngIf="!view.isShared || hasSharedManagePermission"
                                                      (onClick)="pinFilterView(view); $event.stopPropagation()"
                                                      pTooltip="Bỏ ghim" />
                                            <p-button icon="pi pi-trash"
                                                      [text]="true"
                                                      size="small"
                                                      severity="danger"
                                                      *ngIf="!view.isShared || hasSharedManagePermission"
                                                      (onClick)="deleteFilterView(view); $event.stopPropagation()"
                                                      pTooltip="Xóa" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Unpinned Views -->
                        <div *ngIf="unpinnedViews.length > 0" class="filter-view-section">
                            <div class="filter-view-subheader">
                                <span class="text-xs font-semibold uppercase tracking-wide">Bộ lọc khác</span>
                            </div>
                            <div class="flex flex-col ml-2 border-l border-surface">
                                <div *ngFor="let view of unpinnedViews"
                                     class="filter-view-item"
                                     [class.selected]="selectedViewId === view.id"
                                     (click)="selectFilterView(view)">
                                    <div class="flex items-center justify-between gap-1 h-8 relative">
                                        <div class="flex items-center gap-2 flex-1 min-w-0">
                                            <span class="text-sm truncate">{{ view.name }}</span>
                                            <span *ngIf="view.isShared"
                                                  class="text-xs px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded flex-none">
                                                Shared
                                            </span>
                                        </div>
                                        <div class="filter-view-actions flex gap-1 flex-none absolute right-0">
                                            <p-button icon="pi pi-pencil"
                                                      [text]="true"
                                                      size="small"
                                                      severity="secondary"
                                                      *ngIf="!view.isShared || hasSharedManagePermission"
                                                      (onClick)="openEditFilterViewPopover(view, $event); $event.stopPropagation()"
                                                      pTooltip="Chỉnh sửa" />
                                            <p-button icon="pi pi-thumbtack"
                                                      [text]="true"
                                                      size="small"
                                                      severity="secondary"
                                                      *ngIf="!view.isShared || hasSharedManagePermission"
                                                      (onClick)="pinFilterView(view); $event.stopPropagation()"
                                                      pTooltip="Ghim" />
                                            <p-button icon="pi pi-trash"
                                                      [text]="true"
                                                      size="small"
                                                      severity="danger"
                                                      *ngIf="!view.isShared || hasSharedManagePermission"
                                                      (onClick)="deleteFilterView(view); $event.stopPropagation()"
                                                      pTooltip="Xóa" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Empty State -->
                        <div *ngIf="pinnedViews.length === 0 && unpinnedViews.length === 0"
                             class="text-center py-4 text-sm text-slate-400">
                            Chưa có bộ lọc nào
                        </div>
                    </div>
                </div>

                <!-- Main Filter Content (Right Side) -->
                <div class="flex flex-1 flex-col gap-3 p-2 overflow-y-auto">
                    <!-- Header -->
                    <div class="flex flex-none items-center justify-between pb-2 border-b border-surface">
                        <span class="text-sm font-semibold">Bộ lọc nâng cao</span>
                        <div class="flex gap-2">
                            <!-- Save Button - updates current filter view -->
                            <p-button *ngIf="config.showFilterViewPanel && config.entityType"
                                      icon="pi pi-save"
                                      [text]="true"
                                      size="small"
                                      [disabled]="!selectedViewId || !canSaveCurrentView"
                                      (onClick)="saveCurrentFilterView()"
                                      [pTooltip]="saveButtonTooltip || 'Lưu bộ lọc'" />

                            <!-- Save As Button - creates new filter view -->
                            <p-button *ngIf="config.showFilterViewPanel && config.entityType"
                                      icon="pi pi-file"
                                      [text]="true"
                                      size="small"
                                      (onClick)="openSaveAsPopover($event)"
                                      pTooltip="Lưu thành bộ lọc mới" />

                            <p-button *ngIf="config.showClearButton !== false"
                                      icon="pi pi-times"
                                      label="Xóa tất cả"
                                      severity="secondary"
                                      [text]="true"
                                      size="small"
                                      [disabled]="!hasActiveFilters && !hasDraftChanges"
                                      (onClick)="clearFilters()"
                                      pTooltip="Xóa tất cả bộ lọc" />
                            <p-button icon="pi pi-check"
                                      label="Lọc"
                                      severity="secondary"

                                      size="small"
                                      [disabled]="!hasDraftChanges"
                                      (onClick)="applyFilters()"
                                      pTooltip="Thực hiện lọc" />
                        </div>
                    </div>

                    <!-- Popover Filter Fields -->
                    <div class="grid grid-cols-2 gap-3 flex-1 p-2 min-h-0 overflow-y-auto">
                        <ng-container *ngFor="let field of popoverFields">
                            <!-- Text Search Field -->
                            <div *ngIf="field.type === 'text'" class="col-span-2">
                                <label class="block text-xs font-medium text-slate-700 mb-1">{{ field.label }}</label>
                                <p-iconfield>
                                    <p-inputicon class="pi pi-search" />
                                    <input pInputText
                                           type="text"
                                           class="w-full"
                                           [placeholder]="field.placeholder || 'Tìm kiếm...'"
                                           [(ngModel)]="draftFilterValues[field.key]"
                                           (ngModelChange)="onTextChange(field.key, $event)" />
                                    <p-inputicon *ngIf="draftFilterValues[field.key]"
                                                 class="pi pi-times cursor-pointer"
                                                 (click)="draftFilterValues[field.key] = ''; onTextChange(field.key, '')" />
                                </p-iconfield>
                            </div>

                            <!-- Date Range Field (two separate pickers) -->
                            <div *ngIf="field.type === 'dateRange'" class="col-span-2">
                                <label class="block text-xs font-medium text-slate-700 mb-1">{{ field.label }}</label>
                                <div class="flex gap-2 items-center">
                                    <p-datepicker
                                                  styleClass="flex-1"
                                                  showIcon
                                                  [iconDisplay]="'input'"
                                                  [placeholder]="'Từ ngày'"
                                                  dateFormat="dd/mm/yy"
                                                  [(ngModel)]="draftFilterValues[field.key].from"
                                                  (ngModelChange)="onDateRangeChange(field, 'from', $event)"
                                                  [showClear]="true"
                                                  stopOnDateSelectPropagation
                                                  appendTo="body" />
                                    <span class="text-slate-400">-</span>
                                    <p-datepicker
                                                  styleClass="flex-1"
                                                  showIcon
                                                  [iconDisplay]="'input'"
                                                  [placeholder]="'Đến ngày'"
                                                  dateFormat="dd/mm/yy"
                                                  [(ngModel)]="draftFilterValues[field.key].to"
                                                  (ngModelChange)="onDateRangeChange(field, 'to', $event)"
                                                  [showClear]="true"
                                                  stopOnDateSelectPropagation
                                                  appendTo="body" />
                                </div>
                            </div>

                            <!-- Multi-Select Field -->
                            <div *ngIf="field.type === 'multiSelect'" class="col-span-2">
                                <label class="block text-xs font-medium text-slate-700 mb-1">{{ field.label }}</label>
                                <p-multiselect *ngIf="field.selectConfig"
                                               [options]="selectOptions.get(field.key) || []"
                                               [(ngModel)]="draftFilterValues[field.key].values"
                                               (ngModelChange)="onMultiSelectChange(field)"
                                               [placeholder]="field.selectConfig.placeholder || 'Chọn...'"
                                               [filter]="true"
                                               (onFilter)="onSelectFilter(field, $event)"
                                               [loading]="selectLoading.get(field.key) || false"
                                               [showClear]="true"
                                               display="chip"
                                               styleClass="w-full"
                                               optionLabel="label"
                                               optionValue="value"
                                               appendTo="body">
                                    <ng-template pTemplate="footer">
                                        <div class="px-3 py-2 border-t border-slate-200">
                                            <div class="flex items-center gap-2">
                                                <span class="text-xs font-medium text-slate-600">Chế độ:</span>
                                                <p-selectbutton [options]="matchModeOptions"
                                                                [(ngModel)]="draftFilterValues[field.key].mode"
                                                                (ngModelChange)="onMatchModeChange(field)"
                                                                [disabled]="!field.isArrayField"
                                                                [pTooltip]="!field.isArrayField ? 'Trường đơn giá trị, chỉ hỗ trợ chế độ Any' : ''"
                                                                optionLabel="label"
                                                                optionValue="value"
                                                                size="small"
                                                                styleClass="text-xs" />
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-multiselect>
                            </div>

                            <!-- Multi-Select with Priority Field -->
                            <div *ngIf="field.type === 'multiSelectPriority'" class="col-span-2">
                                <label class="block text-xs font-medium text-slate-700 mb-1">{{ field.label }}</label>
                                <p-multiselect *ngIf="field.selectConfig"
                                               [options]="selectOptions.get(field.key) || []"
                                               [(ngModel)]="draftFilterValues[field.key].values"
                                               (ngModelChange)="onMultiSelectChange(field)"
                                               [placeholder]="field.selectConfig.placeholder || 'Chọn...'"
                                               [filter]="true"
                                               (onFilter)="onSelectFilter(field, $event)"
                                               [loading]="selectLoading.get(field.key) || false"
                                               [showClear]="true"
                                               display="chip"
                                               styleClass="w-full"
                                               optionLabel="label"
                                               optionValue="value"
                                               appendTo="body">
                                    <ng-template pTemplate="footer">
                                        <div class="flex flex-col gap-2 px-3 py-2 border-t border-slate-200">
                                            <!-- Match mode toggle -->
                                            <div class="flex items-center gap-2">
                                                <span class="text-xs font-medium text-slate-600">Chế độ:</span>
                                                <p-selectbutton [options]="matchModeOptions"
                                                                [(ngModel)]="draftFilterValues[field.key].mode"
                                                                (ngModelChange)="onMatchModeChange(field)"
                                                                optionLabel="label"
                                                                optionValue="value"
                                                                size="small"
                                                                styleClass="text-xs" />
                                            </div>

                                            <!-- Priority mode dropdown -->
                                            <div *ngIf="field.priorityModeOptions"
                                                 class="flex items-center gap-2">
                                                <span class="text-xs font-medium text-slate-600">Ưu tiên:</span>
                                                <p-select [options]="getPriorityModeOptionsWithNumericValues(field.priorityModeOptions)"
                                                          [(ngModel)]="draftFilterValues[field.key].priority"
                                                          (ngModelChange)="onPriorityModeChange(field)"
                                                          optionLabel="label"
                                                          optionValue="value"
                                                          size="small"
                                                          styleClass="flex-1"
                                                          appendTo="body"
                                                          stopOnOptionSelectPropagation />
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-multiselect>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-popover>

    <!-- Confirm Dialog -->
    <p-confirmdialog></p-confirmdialog>
</div>